import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import { parseDateTime } from '../../../Helpers/dateFormating';


const MaintenanceModal = ({ open, maintenanceReference, onClose}) => {
  if (!maintenanceReference) return null;

  const registration = parseDateTime(maintenanceReference.submissionDate);
  const damage = parseDateTime(maintenanceReference.damageDate);
  const restoration = parseDateTime(maintenanceReference.restorationDate);
  const receipt = parseDateTime(maintenanceReference.createdAt);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Βλαβοληψία</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={2} mt={1}>

          <TextField
            label="Α/Α"
            value={maintenanceReference.serialNumber || ""}
          />

          <TextField
            label="Ημερομηνία Αναγγελίας Βλάβης"
            type="date"
            value={registration.date}
          />

          <TextField
            label="Ώρα Αναγγελίας"
            type="time"
            value={registration.time}
          />

          <FormControl fullWidth>
            <InputLabel>Τύπος Αναφοράς</InputLabel>
            <Select
              value={maintenanceReference.maintenanceType}
              label="Τύπος Αναφοράς"
            >
              <MenuItem value={0}>Επιλέξτε</MenuItem>
              <MenuItem value={1}>ΤΑΚΤΙΚΗ ΣΥΝΤΗΡΗΣΗ</MenuItem>
              <MenuItem value={2}>ΕΠΙΔΙΟΡΘΩΣΗ ΒΛΑΒΗΣ</MenuItem>
            </Select>
          </FormControl>


          <FormControl fullWidth>
            <InputLabel>Τύπος Εξοπλισμού</InputLabel>
            <Select
              value={maintenanceReference.deviceType}
              label="Τύπος Εξοπλισμού"
            >
              <MenuItem value={0}>Επιλέξτε</MenuItem>
              <MenuItem value={1}>ΦΩΤΙΣΤΙΚΟ</MenuItem>
              <MenuItem value={2}>PILLAR CONTROLLER</MenuItem>
              <MenuItem value={3}>NEMA CONTROLLER</MenuItem>
              <MenuItem value={4}>GATEWAY</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="ID Εξοπλισμού"
            value={maintenanceReference.deviceId || ""}
          />

          <TextField
            label="Νομός"
            value={maintenanceReference.county || ""}
          />

          <TextField
            label="Περιοχή"
            value={maintenanceReference.area || ""}
          />

          <TextField
            label="Ημερομηνία Συντήρησης/Βλάβης"
            type="date"
            value={damage.date}
          />

          <TextField
            label="Ώρα Βλάβης"
            type="time"
            value={damage.time || ""}
          />

          <TextField
            label="Αναφορά Βλάβης"
            value={maintenanceReference.reportedFromDetails || ""}
          />

          <FormControl fullWidth>
            <InputLabel>Κατάσταση Βλάβης</InputLabel>
            <Select
              value={maintenanceReference.restorationStatus}
              label="Κατάσταση Βλάβης"
            >
              <MenuItem value={0}>Επιλέξτε</MenuItem>
              <MenuItem value={1}>Ολοκληρώθηκε</MenuItem>
              <MenuItem value={2}>Προς Έλεγχο</MenuItem>
              <MenuItem value={3}>Σε εξέλιξη</MenuItem>
              <MenuItem value={4}>Σε αναμονή-ανάταξη</MenuItem>
            </Select>
          </FormControl>

          <TextField
            label="Ημερομηνία Ανάληψης Βλάβης"
            type="date"
            value={receipt.date}
          />

          <TextField
            label="Ώρα ανάληψης Βλάβης"
            type="time"
            value={receipt.time}
          />

          <FormControl fullWidth>
            <InputLabel>Προτεραιότητα</InputLabel>
            <Select
              value={maintenanceReference.priority}
              label="Προτεραιότητα"
            >
              <MenuItem value={0}>Επιλέξτε</MenuItem>
              <MenuItem value={1}>High-72h</MenuItem>
              <MenuItem value={2}>Low</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Υπαιτιότητα</InputLabel>
            <Select
              value={maintenanceReference.responsibilityOf || ""}
              label="Υπαιτιότητα"
            >
              <MenuItem value={0}>Επιλέξτε</MenuItem>
              <MenuItem value={1}>ΠΕΡΙΦΕΡΕΙΑΣ</MenuItem>
              <MenuItem value={2}>ΑΝΑΔΟΧΟΥ</MenuItem>
            </Select>
          </FormControl>

          <Typography>ΕΡΓΑΣΙΕΣ ΑΠΟΚΑΤΑΣΤΑΣΗΣ</Typography>

          <TextField
            label="Περιγραφή εργασιών αποκατάστασης"
            multiline
            minRows={3}
            value={maintenanceReference.restorationWork || ""}
          />


          <TextField
            label="Ημερομηνία Ανάληψης Βλάβης"
            type="date"
            value={restoration.date}
          />

          <TextField
            label="Ώρα ανάληψης Βλάβης"
            type="time"
            value={restoration.time}
          />

          <TextField
            label="Σχόλια"
            multiline
            minRows={3}
            value={maintenanceReference.notes || ""}
          />

          <FormControl fullWidth>
            <InputLabel>Κατάσταση</InputLabel>
            <Select
              value={maintenanceReference.restorationStatus || ""}
              label="Κατάσταση"
            >
              <MenuItem value={1}>Σε εξέλιξη</MenuItem>
              <MenuItem value={2}>Ολοκληρώθηκε</MenuItem>
            </Select>
          </FormControl>

        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default MaintenanceModal;